import { core } from '@tock/coretypes';
import AppConstants from 'constants/AppConstants';

export function clear(): BaseTockAction {
  return {
    type: AppConstants.PACKAGE_CLEAR,
  };
}

export function selectPackage(ticketTypePackage: core.TicketTypePackage): BaseTockAction {
  return {
    type: AppConstants.PACKAGE_SELECT_PACKAGE,
    payload: ticketTypePackage.id,
  };
}

export function selectSize(size: number): BaseTockAction {
  return {
    type: AppConstants.PACKAGE_SELECT_SIZE,
    payload: size,
  };
}

export function selectDate(ticketTypeId: number, date: string): BaseTockAction {
  return {
    type: AppConstants.PACKAGE_SELECT_DATE,
    payload: {
      ticketTypeId,
      date,
    },
  };
}

export function selectTime(ticketTypeId: number, time: string): BaseTockAction {
  return {
    type: AppConstants.PACKAGE_SELECT_TIME,
    payload: {
      ticketTypeId,
      time,
    },
  };
}

export function selectOptions(ticketTypeId: number, options: core.IOptionOrder[]): BaseTockAction {
  return {
    type: AppConstants.PACKAGE_SELECT_OPTIONS,
    payload: {
      ticketTypeId,
      options,
    },
  };
}

export function confirmChoices(ticketTypeId: number): BaseTockAction {
  return {
    type: AppConstants.PACKAGE_CONFIRM_CHOICES,
    payload: {
      ticketTypeId,
    },
  };
}

export function editChoices(ticketTypeId: number): BaseTockAction {
  return {
    type: AppConstants.PACKAGE_EDIT_CHOICES,
    payload: {
      ticketTypeId,
    },
  };
}
